export class AssetInfo {
  hash_id?: string = '';
  thumbImgUrl: string = '';
  imgUrl: string = '';
  userType?: string = '';
  assetType?: any = '';
  isDelete?: number = 0;
}

export class FcmNotification {
  topicTitle: string = '';
  topicMessage: string = '';
  targetId: any = 1;
  topicDescription: string = '';
  topicType: string = 'promotion';
  topic: string = '';
}

export class ServiceList{
  
    
    serviceName: string = '';
    approxTime: any = null;
    description: string = '';
    sac_code: any = null;
    shop_rate: any = null;
    home_rate: any = null;
    virtualRate: any = null;
    virtual_rate: any = null;
    imgUrl: any = 'null';
    thumbUrl: any = 'null';
    status: number = 1;
    homeStatus: number = 0;
    shopStatus: number = 0;
    virtualStatus: number = 0; 
    for_virtual: number = 0; 
    discountStatus: any = null;
    discountAmount: any = null;
    discountType: any = null;
    shopDiscountedPrice: any = null;
    homeDiscountedPrice: any = null;
    virtualDiscountedPrice: any =  0; 
    virtual_discounted_amount: any =  null; 
    service_category_hash: any = null;
    tax_collecion_status: number = 0;
        is_available_online: number = 0;

    tax_collection_status: number = 0;
    tax_slab_hash: any = null;

    rate: number = 0;
}

export class ServiceTemplate{
    serviceName: string = '';
    approxTime: any = null;
    description: string = '';
    shop_rate: any = null;
    home_rate: any = null;
    imgUrl: any = 'null';
    status: number = 1;
}

export class BuisnessPromotion {
  hash_id: any = '';
  postTitle: string = '';
  postType: any = '';
  title: string = '';
  description: string = '';
  imgUrl: string = '';
  targetUser: string = '';
  targetCity: any = undefined;
  targetState: any = undefined;
  targetCountry: any = undefined;
  publishDate: string = '';
  expireDate: string = '';
  externalLink: string = '';
  assetInfo: AssetInfo[] = [];
  isDelete: number = 0;
  creationDate: string = '';
  status: number = 1;
  searchType: any = '';
}
